<template>
    <div>
        {{ getDropdowns(qid) }}

        <div class="form-group row d-flex align-items-center">
            <div class="col-lg-12" v-if="dropdowns && dropdowns.length > 0">
                <select class="form-control mb-3" v-on:change="updateAnswer($event.target.value)">
                    <option value="">Select an option</option>
                    <option v-for="dropdown in dropdowns" v-bind:naCommentValue="dropdown.dropdown">{{ dropdown.dropdown }}</option>
                </select>
            </div>
            <div class="col-lg-12">
                <textarea
                        v-bind:placeholder="placeholder"
                        v-model="naCommentValue"
                        @input="$emit('input', naCommentValue)"
                        class="form-control"></textarea>
            </div>
        </div>
    </div>
</template>





<script>

    export default {
        props: [
            'value',
            'qid',
        ],
        data() {
            return {
                naCommentValue: this.value,
                dropdowns: [],
                placeholder: 'Add comments here'
            }
        },
        watch: {
          value(newValue) {
              this.naCommentValue = newValue;
          }
        },
        methods: {
            updateAnswer(newValue) {
                if (this.naCommentValue === null) {
                    this.naCommentValue = newValue;
                } else if(newValue.length > 0) {
                    this.naCommentValue = this.naCommentValue + ' ' + newValue;
                }
                console.log('Comment value', this.naCommentValue);
                this.$emit('input', this.naCommentValue);
            },
            getContainerClasses(field) {
                return this.$parent.getContainerClasses(field);
            },
            getDropdowns(questionId) {
                var vm = this;
                this.getDb(function onConnectedGetDropdowns(db) {
                    var dropdownsStore = db.transaction('dropdowns').objectStore('dropdowns');
                    if (dropdownsStore) {
                        var questionResults = dropdownsStore.index('question_id').getAll(questionId);
                        questionResults.onsuccess = function(e) {
                            vm.dropdowns = e.target.result;
                            if(vm.dropdowns && vm.dropdowns.length > 0) {
                                vm.placeholder = 'Select options from dropdown above or enter your comments';
                            }
                            return e.target.result;
                        }
                        questionResults.onerror = function(e) {
                            console.log('Problem', e);
                        }
                    }
                })
            },
        },
    }
</script>